import { createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/icon/printer-orange-outline.png'


const _hoisted_1 = { id: "delivery-manifest" }
const _hoisted_2 = { class: "flex flex-col sm:flex-row items-left justify-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal w-full sm:w-max" }, "Manifest Pengiriman")
], -1)
const _hoisted_4 = { class: "flex mb-4" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", {
  class: "pi pi-sort text-base cursor-pointer text-black mr-1",
  "aria:haspopup": "true"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "text-black font-semibold text-sm text-center" }, "Urutkan", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("i", {
  class: "pi pi-calendar text-base cursor-pointer text-black mr-1",
  "aria:haspopup": "true"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "text-black font-semibold text-sm text-center" }, "Tanggal", -1)
const _hoisted_9 = {
  key: 0,
  class: " background-orange-lighten-5 py-2 px-4 relative mt-4 mb-4 rounded-md shadow cursor-pointer col-span-2 "
}
const _hoisted_10 = { class: " flex md:flex-row flex-col items-center sm:items-start justify-between" }
const _hoisted_11 = { class: " flex flex-row items-center sm:justify-start md:w-auto py-3 w-full" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  alt: " ",
  src: _imports_0,
  class: "mr-3"
}, null, -1)
const _hoisted_13 = { class: " font-bold text-primary-dark-2  lg:text-lg md:text-lg text-sm" }
const _hoisted_14 = { class: "flex  items-center md:w-auto w-full md:py-2 pt-4" }
const _hoisted_15 = {
  class: " flex flex-col items-center p-button p-component p-button p-button-sm rounded-lg  py-1 px-2 md:w-auto  w-full",
  type: "button"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "text-white font-bold lg:text-base md:text-sm text-sm" }, "Print ", -1)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "flex items-center justify-between mb-1" }
const _hoisted_19 = { class: "font-bold" }
const _hoisted_20 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  focusable: "false",
  class: "w-6 h-6",
  style: {"-ms-transform":"rotate(180deg)","-webkit-transform":"rotate(180deg)","transform":"rotate(180deg)"},
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "#78909C",
    d: "M19 11H7.14l3.63-4.36a1 1 0 1 0-1.54-1.28l-5 6a1.19 1.19 0 0 0-.09.15c0 .05 0 .08-.07.13A1 1 0 0 0 4 12a1 1 0 0 0 .07.36c0 .05 0 .08.07.13a1.19 1.19 0 0 0 .09.15l5 6A1 1 0 0 0 10 19a1 1 0 0 0 .64-.23a1 1 0 0 0 .13-1.41L7.14 13H19a1 1 0 0 0 0-2z"
  })
], -1)
const _hoisted_21 = { class: "lg:flex md:flex block items-end md:justify-between lg:justify-between" }
const _hoisted_22 = { class: "detail-info lg:w-auto md:w-auto w-full" }
const _hoisted_23 = { class: "flex items-center mb-2" }
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-darken-1 mr-1" }, "Berangkat :", -1)
const _hoisted_25 = {
  key: 0,
  class: "text-black"
}
const _hoisted_26 = {
  key: 1,
  class: "text-black"
}
const _hoisted_27 = { class: "flex items-center" }
const _hoisted_28 = { class: "flex items-center pr-0 sm:pr-3 mr-3 flex-initial" }
const _hoisted_29 = {
  class: "rounded-md background-green-lighten-5 py-1 px-3 mr-2",
  style: {"border":"1px solid #66BB6A"}
}
const _hoisted_30 = { class: "color-green-darken-1 text-sm" }
const _hoisted_31 = {
  class: "flex items-center flex-initial my-3 pl-2 sm:my-0",
  style: {"border-left":"2px solid #B0BEC5"}
}
const _hoisted_32 = { class: "color-blue-grey mr-3" }
const _hoisted_33 = { class: "color-blue-grey" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode()
const _hoisted_35 = { class: "text-black" }
const _hoisted_36 = { class: "color-blue-grey" }
const _hoisted_37 = { class: "color-blue-grey" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode()
const _hoisted_39 = { class: "text-black" }
const _hoisted_40 = { class: "price-info text-right lg:w-auto md:w-auto w-full" }
const _hoisted_41 = { class: "flex items-center" }
const _hoisted_42 = { class: "color-primary" }
const _hoisted_43 = { class: "flex items-center" }
const _hoisted_44 = { class: "color-primary font-bold" }
const _hoisted_45 = {
  key: 2,
  class: "py-4 px-5 text-center color-blue-grey"
}
const _hoisted_46 = { class: "p-col-12 block" }
const _hoisted_47 = { class: "btn-action w-full flex justify-end mt-5" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Clear Filter")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_router_link = _resolveComponent("router-link")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_Calendar = _resolveComponent("Calendar")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", null, [
            _createVNode(_component_InputIconRightGrey, {
              modelValue: _ctx.inputSearch,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputSearch = $event)),
              placeholder: "Cari Disini ...",
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.searchData(_ctx.inputSearch)), ["enter"])),
              type: _ctx.$enumBase.input.text,
              icon: _ctx.$icon.svg.searchEva,
              class: "mt-3 sm:mt-0"
            }, null, 8, ["modelValue", "type", "icon"])
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", {
            class: "filterChips",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSortFilter($event)))
          }, [
            _hoisted_5,
            _hoisted_6
          ]),
          _createVNode("div", {
            class: "filterChips",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDateFilter($event)))
          }, [
            _hoisted_7,
            _hoisted_8
          ]),
          (_ctx.$store.state.device.width < 640)
            ? (_openBlock(), _createBlock(_component_SelectButton, {
                key: 0,
                class: "select-on select-on-small",
                modelValue: _ctx.ritFilter,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.ritFilter = $event)),
                options: _ctx.ritOption,
                optionValue: "value",
                optionLabel: "name",
                multiple: ""
              }, null, 8, ["modelValue", "options"]))
            : (_openBlock(), _createBlock(_component_SelectButton, {
                key: 1,
                class: "select-on",
                modelValue: _ctx.ritFilter,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.ritFilter = $event)),
                options: _ctx.ritOption,
                optionValue: "value",
                optionLabel: "name",
                multiple: ""
              }, null, 8, ["modelValue", "options"]))
        ]),
        (_ctx.lastManifestExist)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode("p", _hoisted_13, "Terakhir diprint: " + _toDisplayString(_ctx.lastNoManifest), 1)
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("button", _hoisted_15, [
                    _createVNode("div", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.printResi(_ctx.lastManifestId)))
                    }, [
                      _hoisted_16
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.data.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  class: "cursor-pointer",
                  to: {name: 'transaksi-manifest-pengiriman-detail', params: { id: item.IdJadwal }},
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Card, { class: "card-no-shadow card-item-category mb-4" }, {
                      content: _withCtx(() => [
                        _createVNode("div", _hoisted_18, [
                          _createVNode("h5", _hoisted_19, _toDisplayString(item.KodeJadwal), 1),
                          _createVNode(_component_Button, { class: "p-button-link px-1" }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode("div", _hoisted_21, [
                          _createVNode("div", _hoisted_22, [
                            _createVNode("div", _hoisted_23, [
                              _hoisted_24,
                              (item.Group == 2)
                                ? (_openBlock(), _createBlock("p", _hoisted_25, _toDisplayString(`${item.KeteranganHari.trim()}, ${item.WaktuKeberangkatan}`), 1))
                                : _createCommentVNode("", true),
                              (item.Group == 1)
                                ? (_openBlock(), _createBlock("p", _hoisted_26, _toDisplayString(`${_ctx.moment(item.WaktuKeberangkatan).format('dddd, DD MMMM YYYY')}`), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_27, [
                              _createVNode("div", _hoisted_28, [
                                _createVNode("div", _hoisted_29, [
                                  _createVNode("p", _hoisted_30, "RIT " + _toDisplayString(item.Rit), 1)
                                ]),
                                _createVNode("div", _hoisted_31, [
                                  _createVNode("p", _hoisted_32, [
                                    _createVNode("b", _hoisted_33, _toDisplayString(item.Group == 1 ? 'Total Resi :': 'Resi Anda :'), 1),
                                    _hoisted_34,
                                    _createVNode("b", _hoisted_35, _toDisplayString(item.TotalResi), 1)
                                  ]),
                                  _createVNode("p", _hoisted_36, [
                                    _createVNode("b", _hoisted_37, _toDisplayString(item.Group == 1 ? 'Total Barang :': 'Barang Anda :'), 1),
                                    _hoisted_38,
                                    _createVNode("b", _hoisted_39, _toDisplayString(item.TotalBarang), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_40, [
                            _createVNode("div", _hoisted_41, [
                              _createVNode("p", _hoisted_42, _toDisplayString(item.Group == 1 ? 'Pendapatan Total' : 'Pendapatan Anda'), 1)
                            ]),
                            _createVNode("div", _hoisted_43, [
                              _createVNode("h5", _hoisted_44, "Rp " + _toDisplayString(new Number(item.Pendapatan).toLocaleString('id-ID')), 1)
                            ])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ]))
          : (_openBlock(), _createBlock("p", _hoisted_45, "Manifest pengiriman tidak ditemukan"))
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, {
      ref: "sortOp",
      id: "sort_overlay_panel",
      class: "p-5"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortingOption, (data, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "p-field-radiobutton mb-2",
            key: 'sortby-' + index,
            onChange: ($event: any) => (_ctx.changeSortBy(data.value))
          }, [
            _createVNode(_component_RadioButton, {
              id: 'sortby-' + index,
              class: "mr-2 radioScheduleBus",
              value: data.value,
              onChange: ($event: any) => (_ctx.changeSortBy(data.value)),
              modelValue: _ctx.sortBy,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortBy = $event))
            }, null, 8, ["id", "value", "onChange", "modelValue"]),
            _createVNode("label", {
              class: "cursor-pointer",
              for: 'sortby-' + index
            }, _toDisplayString(data.name), 9, ["for"])
          ], 40, ["onChange"]))
        }), 128))
      ]),
      _: 1
    }, 512),
    _createVNode(_component_OverlayPanel, {
      ref: "dateOp",
      id: "filter_overlay_panel",
      class: "p-5"
    }, {
      default: _withCtx(() => [
        _createVNode("span", _hoisted_46, [
          _createVNode(_component_Calendar, {
            modelValue: _ctx.dateFilter,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dateFilter = $event)),
            inline: true,
            showWeek: true
          }, null, 8, ["modelValue"]),
          _createVNode("div", _hoisted_47, [
            (_ctx.dateFilter)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Filter",
                  class: "font-semibold p-button-sm btn-primary px-10 mr-2",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveFilterDate()))
                }))
              : _createCommentVNode("", true),
            (_ctx.dateFilter)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "btn-secondary text-black p-button-sm px-10 py-1",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.clearFilterDate()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_48
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}